import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { beautyBaseUrl } from "network";

export const timeslotSlice = createApi({
    reducerPath: "timeslotSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: beautyBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getTmeslots: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/timeSlot?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Location
        addTimeslot: builder.mutation({
            query: (body) => ({
                url: "/timeSlot",
                method: "POST",
                body,
            }),
        }),

        // ✅ Add New Location
        getSingleTimeslot: builder.query({
            query: ({id, locId}) => ({
                url: `/timeSlot/day/${id}/${locId}`,
                method: "get",

            }),
        }),



        // ✅ Update Existing Category
        updateTimeslot: builder.mutation({
            query: ({ id, body }) => ({
                url: `/timeSlot/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // updateTimeslot: builder.mutation({
        //     query: ({ id, body }) => {
        //         console.log('Updating timeslot:', id, body); // ✅ Log safely here
        //         return {
        //             url: `/timeSlot/${id}`,
        //             method: "PUT",
        //             body,
        //         };
        //     },
        // }),


        // ✅ Delete Category
        deleteTimeslot: builder.mutation({
            query: (id) => ({
                url: `/timeSlot/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useGetTmeslotsQuery,
    useAddTimeslotMutation,
    useGetSingleTimeslotQuery,
    useUpdateTimeslotMutation,
    useDeleteTimeslotMutation

} = timeslotSlice;
